import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'reactstrap';
import {
  changeHandler,
  clearPickUpSlots,
  createPickUpNotification,
  disableGoToNextStep,
  getPickUpDeliveryTimeSlots,
  saveSelectedPickUpSlot,
  saveToHistory,
  setCurrentStep,
  setPickUpNotes,
} from '../IMEIDeviceRepairSlice';
import Title from '../Shared/Title';
import UpdateBusinessDeliverySlotHolder from '../UpdateBusinessDeliverySlotHolder/UpdateBusinessDeliverySlotHolder';

const UpdateDeliveries = (props) => {


  return (
    <Container className='delivery-slot-container'>
      <Row className='delivery-slot-holder'>
        <Col>
          <Row>
            <Col>
              <Title text={`סטטוס ועדכון שליחות`} subtext={`מתי נפגשים?`} />
            </Col>
          </Row>
          <Row>
            <Col>
              <p className='delivery-text'>כאן תוכלו לראות למתי מתואמת לכם שליחות ולעדכן את המועד שלה</p>
            </Col>
          </Row>
          <Col className='slots-container'>
            <UpdateBusinessDeliverySlotHolder props={props} contentData={props.contentData}/>
          </Col>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {deviceRepairData: state.iMEIDeviceRepair, addressForm: state.addressForm};
};

const mapDispatchToProps = {
  setPickUpNotes,
  changeHandler,
  setCurrentStep,
  disableGoToNextStep,
  getPickUpDeliveryTimeSlots,
  clearPickUpSlots,
  saveSelectedPickUpSlot,
  createPickUpNotification,
  saveToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateDeliveries);
